import { grommet} from "grommet";
import { deepMerge } from "grommet/utils";


export default deepMerge(grommet, {
  global: {
    breakpoints: {
      small: {
        value: 1200,
      },
    },
    colors: {
      brand: "#747264",
    },
    font: {
      // family: "Lora",
      size: "14px",
      height: "20px",
    },
    focus: {
      border: {
        color: "grey",
      },
    },
  },
});
